import BaseLayout from ".";

export default function HomeLayout() {
  return <BaseLayout isHome />;
}
